<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      {{ elementGrade }}
      <feather-icon icon="AlertTriangleIcon"  class="text-danger" svgClasses="h-5 w-5 mr-4 hover:text-primary"  v-if="hasQAWarning === 2"  />
      <feather-icon icon="AlertTriangleIcon"  class="text-warning" svgClasses="h-5 w-5 mr-4 hover:text-primary"  v-if="hasQAWarning === 1"  />
    </div>
</template>

<script>
export default {
  name: 'ElementGradeCellRenderer',
  computed: {
    hasQAWarning() {
      return this.params.value.hasWarning;
    },
    elementGrade() {
      return this.params.value.grade;
    }
  }
}
</script>
